import React, { useEffect, useState } from "react";
import {
  DialogActions,
  IconButton,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import ContentLayout from "../../../../partials/content/ContentLayout";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import DialogLayout from "../../../../partials/content/DialogLayout";
import { formatDate } from "../../../../utils/utils";
import { getFiscalYearPeriods } from "../../../../services/setup/finance/financeSetupService";
import { getCompanyPreferences } from "../../../../services/setup/company-profile/companyProfileService";
import { updateAutoClosingPeriod } from "../../../../services/finance/finance";
import OpenClosePeriodForm from "./openClosePeriodForm";
import { Badge } from "react-bootstrap";
import { Checkbox } from "primereact/checkbox";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import { Search } from "@mui/icons-material";
import Illustration from "../../../../partials/content/Illustration";
function FiscalPeriodList({ history }) {
  const { currentFiscalYear, reload } = useGlobalData();
  const fiscalPeriodDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];
  const [openForm, setOpenForm] = useState(false);
  const [fiscalPeriodList, setFiscalPeriodList] = useState([]);
  const [fiscalPeriod, setFiscalPeriod] = useState({});
  const [fiscalYear, setFiscalYear] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [companyPreferences, setCompanyPreferences] = useState({});
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  useEffect(() => {
    getPeriodListData(fiscalYear.ID);
    getCompanyPreferencesData();
  }, [reload]);

  return (
    <React.Fragment>
      <PageSubHeader
        title="Open / Close Fiscal Period"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/open-close-period",
            title: "Open / Close Fiscal Periods",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
        ]}
      />
      <ContentLayout>
        <div className="row mb-3">
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="row">
              <div className="col-sm-12 col-md-10 col-lg-8">
                <TextField
                  id="fiscalYear"
                  label="Fiscal Year"
                  value={
                    fiscalYear.startMonthName +
                    " " +
                    fiscalYear.year +
                    " - " +
                    fiscalYear.endMonthName +
                    " " +
                    fiscalYear.yearTo
                  }
                  style={{ width: "100%" }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYear(true);
                            }}
                            edge="end"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                      </InputAdornment>
                    ),
                    readOnly: true,
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-6">
            <div className="p-field-checkbox my-2 text-left float-md-right">
              <Checkbox
                icon="pi pi-check-circle"
                inputId="autoClosing"
                checked={companyPreferences.autoClosingPeriod}
                onChange={(e) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                      cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  })
                    .fire({
                      title: `Are you sure want to ${
                        companyPreferences.autoClosingPeriod === true
                          ? "disable"
                          : "activate"
                      } this Auto Fiscal Period Closing ?`,
                      text:
                        "Please note that you are responsible for this action",
                      icon: "question",
                      showCloseButton: true,
                      showCancelButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, ${
                        companyPreferences.autoClosingPeriod === true
                          ? "disable"
                          : "activate"
                      } it`,
                      cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                      reverseButtons: true,
                    })
                    .then((result) => {
                      if (result.isConfirmed) {
                        updateAutoClosingPeriod({
                          ID: companyPreferences.ID,
                          companyProfileID: companyPreferences.companyProfileID,
                          autoClosingPeriod: e.checked,
                        }).then((response) => {
                          Swal.mixin({
                            customClass: {
                              confirmButton:
                                "btn btn-success btn-md btn-pill btn-bold",
                            },
                            buttonsStyling: false,
                          }).fire({
                            title: `${
                              companyPreferences.autoClosingPeriod === true
                                ? "Disabled"
                                : "Activated"
                            }`,
                            html: response.data.message,
                            icon: "success",
                            showCloseButton: true,
                            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                          });
                          getPeriodListData(fiscalYear.ID);
                          getCompanyPreferencesData();
                        });
                      } else if (result.dismiss === Swal.DismissReason.cancel) {
                        Swal.mixin({
                          customClass: {
                            confirmButton:
                              "btn btn-success btn-md btn-pill btn-bold",
                          },
                          buttonsStyling: false,
                        }).fire({
                          title: "Cancelled",
                          text: "No change has been made",
                          icon: "info",
                          showCloseButton: true,
                          confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                        });
                      }
                    });
                }}
              />
              <label htmlFor="autoClosing">Auto Fiscal Period Closing</label>
            </div>
          </div>
        </div>
        {fiscalPeriodList.length ? (
          <CustomDataTable
            data={fiscalPeriodList}
            dataDetailColumns={fiscalPeriodDetailColumn}
            onRefreshData={() => {
              getPeriodListData(fiscalYear.ID);
            }}
            columns={[
              {
                header: "Year",
                field: "year",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Month",
                field: "monthName",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Period Status",
                field: "statusName",
                body: (rowData) => {
                  if (rowData.statusID === 1) {
                    return <Badge variant="danger">{rowData.statusName}</Badge>;
                  } else if (rowData.statusID === 2) {
                    return (
                      <Badge variant="primary">{rowData.statusName}</Badge>
                    );
                  } else if (rowData.statusID === 3) {
                    return (
                      <Badge variant="success">{rowData.statusName}</Badge>
                    );
                  } else {
                    return <Badge variant="dark">{rowData.statusName}</Badge>;
                  }
                },
                sortable: true,
                filter: true,
              },
              {
                header: "Opening Date",
                field: "openingDate",
                body: (rowData) => formatDate(rowData.openingDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Closing Date",
                field: "closingDate",
                body: (rowData) => formatDate(rowData.closingDate),
                sortable: true,
                filter: true,
              },
              {
                header: "Actions",
                body: (rowData) => (
                  <React.Fragment>
                    {rowData.statusID !== 3 ? (
                      <BootstrapTooltip title="Edit Fiscal Period Status">
                        <button
                          type="button"
                          onClick={(event) => {
                            setFiscalPeriod(rowData);
                            setOpenForm(true);
                          }}
                          className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                      </BootstrapTooltip>
                    ) : null}
                  </React.Fragment>
                ),
                sortable: false,
              },
            ]}
          />
        ) : (
          <Illustration
            imageSource="INVIFO Payment.png"
            description="Hooray! You're ready to Open or Close Fiscal Period!"
            guidance="Hint: perform fiscal period month-end closing regularly just before starting the new month for accurate financial reports"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
      <DialogLayout
        open={openForm}
        title="Open Close Period Form"
        onCloseDialog={() => {
          setOpenForm(false);
        }}
        maxWIdth="sm"
      >
        <OpenClosePeriodForm
          period={fiscalPeriod}
          onConfirmSave={() => {
            setOpenForm(false);
            getPeriodListData(fiscalYear.ID);
          }}
          onCloseDialog={() => {
            setOpenForm(false);
          }}
        />
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            setFiscalYear({
              ID: fiscalYear.ID,
              year: fiscalYear.year,
              yearTo: fiscalYear.yearTo,
              startMonth: fiscalYear.startMonth,
              startMonthName: fiscalYear.startMonthName,
              endMonth: fiscalYear.endMonth,
              endMonthName: fiscalYear.endMonthName,
            });
            getPeriodListData(fiscalYear.ID);
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getPeriodListData(fiscalYearID = 0) {
    const response = await getFiscalYearPeriods(fiscalYearID);
    const { data } = response.data;
    setFiscalPeriodList(data.fiscalPeriods);
  }

  async function getCompanyPreferencesData() {
    const response = await getCompanyPreferences();
    const { data } = response.data;
    const { companyPreferences } = data;
    setCompanyPreferences(companyPreferences);
  }
}

export default FiscalPeriodList;
